<template>
  <div class="top-bar-entel">
    <div class="container">
      <div class="row">
        <div class="col-3 col-lg-4 top-bar-menu-toggler-wrapper">
          <div
            class="relative"
            v-if="typeof this.$route.query.operador === 'undefined'"
          >
            <button
              @click="toggleMenu"
              type="button"
              class="top-bar-menu-toggler"
              aria-controls="navbarResponsive"
              :aria-expanded="site.isSiteMenuVisible"
              aria-label="Mostrar menú"
            >
              <span></span>
            </button>
            <div
              :class="{
                'top-bar-user-menu': true,
                'top-bar-user-menu-visible': isMenuVisible,
              }"
              style="right: auto"
            >
              <ul>
                <li v-for="pagina in paginas" :key="pagina.id">
                  <a :href="'/pagina/' + pagina.guid">{{ pagina.titulo }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-8 col-lg-4 top-bar-logo-wrapper">
          <router-link to="/" class="top-bar-logo gtm_home">
            <img
              v-if="portal.id != 0"
              :src="portal.foto_principal.replace('http:', 'https:')"
            />
          </router-link>
        </div>
        <div
          class="col-3 col-lg-8 d-flex justify-content-end align-items-center"
        >
          <div
            style="display: flex"
            v-if="typeof this.$route.query.operador === 'undefined'"
          >
            <div class="top-bar-estaticas" v-if="paginas.length">
              <ul>
                <li v-for="pagina in paginas" :key="pagina.id">
                  <a :href="'/pagina/' + pagina.guid" class="top-bar-link">{{
                    pagina.titulo
                  }}</a>
                </li>
              </ul>
            </div>

            <div
              v-if="isLoggedIn && misCursos"
              class="d-flex align-items-center justify-content-end relative mr-10"
            >
              <button
                v-if="user.all_access_active == 1"
                class="btn top-bar-user-toggle alinear"
              >
                <span class="top-bar-username" style="color: #24ccc0"
                  >Suscripción Activa</span
                >
                &nbsp;
                <span class="barra-vertical">|</span>
              </button>
              <button
                v-else
                class="btn top-bar-user-toggle alinear"
                @click="toggleCursoMenu"
              >
                <span class="top-bar-username" style="color: #24ccc0"
                  >Mis Cursos</span
                >
                &nbsp;
                <span class="barra-vertical">|</span>
              </button>
              <div
                v-if="user.all_access_active != 1"
                :class="{
                  'top-bar-user-menu': true,
                  'top-bar-user-menu-visible': isCursoMenuVisible,
                }"
                style="
                  width: 450px;
                  right: auto;
                  padding: 0px;
                  background-color: rgba(13, 42, 54, 255);
                "
              >
                <ul style="overflow: auto; height: 200px">
                  <li
                    class="hover-link-curso"
                    v-for="(curso, i) in misCursos"
                    :key="i"
                  >
                    <span
                      v-if="
                        curso &&
                        curso.detalles_compras &&
                        curso.detalles_compras.compras_productos[0]
                      "
                    >
                      <a
                        :href="
                          '/curso/' +
                          getCategoriaProducto(
                            curso.detalles_compras.compras_productos[0]
                          ).guid
                        "
                        style="color: #afafaf"
                      >
                        <div class="row">
                          <div class="col col-md-4">
                            <div
                              class="top-bar-user-photo"
                              style="
                                display: inline-block;
                                width: 100px;
                                height: 60px;
                                margin-right: 20px;
                              "
                            >
                              <img
                                v-if="
                                  curso.detalles_compras.compras_productos[0]
                                    .foto_principal == ''
                                "
                                style="display: block; display: inline-flex"
                                :src="require(`@/assets/images/anon.svg`)"
                                alt
                              />
                              <img
                                v-else
                                style="
                                  display: block;
                                  display: inline-flex;
                                  margin-right: 20px;
                                "
                                :src="
                                  curso.detalles_compras.compras_productos[0].foto_principal.replace(
                                    'http:',
                                    'https:'
                                  )
                                "
                                alt
                              />
                            </div>
                          </div>
                          <div class="col col-md-8">
                            {{
                              curso.detalles_compras.compras_productos[0]
                                .producto
                            }}
                          </div>
                        </div>
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="isLoggedIn" class="d-flex align-items-center justify-content-end relative">
              <button
                class="btn top-bar-user-toggle alinear"
                @click="toggleUserMenu"
              >
                <span class="top-bar-username">{{ user.name }}</span>
                <div
                  class="top-bar-user-photo"
                  :style="{
                    backgroundImage: userHasPhoto
                      ? userPhoto.replace('http:', 'https:')
                      : '',
                  }"
                >
                  <img
                    v-if="!userHasPhoto"
                    :src="require(`@/assets/images/anon.svg`)"
                    alt
                  />
                </div>
              </button>
              <div
                :class="{
                  'top-bar-user-menu': true,
                  'top-bar-user-menu-visible': isUserMenuVisible,
                }"
              >
                <ul>
                  <li>
                    <router-link to="/perfil">Mi perfil</router-link>
                  </li>
                  <li>
                    <button class="top-bar-user-menu-logout" @click="logout">
                      Cerrar sesión
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else class="relative top-bar-mobile-guest-menu-toggler">
              <button class="btn top-bar-user-toggle" @click="toggleUserMenu">
                <div class="top-bar-user-photo">
                  <img
                    v-if="!userHasPhoto"
                    :src="require(`@/assets/images/anon.svg`)"
                    alt
                  />
                </div>
              </button>
              <div
                :class="{
                  'top-bar-user-menu': true,
                  'top-bar-user-menu-visible': isUserMenuVisible,
                }"
              >
                <ul>
                  <li>
                    <a
                      class="gtm-home-login"
                      href="#"
                      @click="toggleLoginModal(true)"
                      >Iniciar sesión</a
                    >
                  </li>
                  <li>
                    <a
                      class="gtm-home-registro"
                      href="#"
                      @click="toggleRegistroModal(true)"
                      >Registro</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="!isLoggedIn" class="top-bar-user-guest">
              <a
                href="https://blog.topclass.cl/"
                target="blank"
                class="top-bar-link text-white"
                style="margin-right:14px; padding-right:14px"
              >BLOG
              </a>
              <a
                href="#Registro"
                class="top-bar-link top-bar-link-active gtm-home-registro"
                title="Registro"
                @click="toggleRegistroModal(true)"
                >Registro</a
              >
              <a
                href="#login"
                class="top-bar-link gtm-home-login"
                title="Iniciar sesión"
                @click="toggleLoginModal(true)"
                >Iniciar sesión</a
              >
              <img
                class="top-bar-anon"
                :src="require(`@/assets/images/anon.svg`)"
                alt
              />

            </div>
          </div>
        </div>
      </div>
      <div
        class="site-menu"
        style="margin-right: 40px"
        v-if="site.isSiteMenuVisible"
      >
        <ul v-if="isLoggedIn">
          <li
            v-if="user.all_access_active == 1"
            style="
              border-bottom: solid 1px #24ccc0;
              margin-bottom: 12px;
              border-top: solid 1px #24ccc0;
              padding-top: 12px;
            "
          >
            <a>Suscripcioń Activa</a>
          </li>
          <li
            v-else
            style="
              border-bottom: solid 1px #24ccc0;
              margin-bottom: 12px;
              border-top: solid 1px #24ccc0;
              padding-top: 12px;
            "
          >
            <a>Mis Cursos</a>
          </li>
        </ul>
        <ul
          v-if="isLoggedIn && misCursos && user.all_access_active != 1"
          style="height: 200px; overflow: auto"
        >
          <li v-for="(curso, i) in misCursos" :key="i">
            <span
              v-if="
                curso &&
                curso.detalles_compras &&
                curso.detalles_compras.compras_productos.length > 0
              "
            >
              <a
                :href="
                  '/curso/' +
                  getCategoriaProducto(
                    curso.detalles_compras.compras_productos[0]
                  ).guid
                "
              >
                <div class="row">
                  <div class="col col-md-3">
                    <div
                      class="top-bar-user-photo"
                      style="
                        display: inline-block;
                        width: 100px;
                        height: 60px;
                        margin-right: 20px;
                      "
                    >
                      <img
                        v-if="
                          curso.detalles_compras.compras_productos[0]
                            .foto_principal == ''
                        "
                        style="display: block; display: inline-flex"
                        :src="require(`@/assets/images/anon.svg`)"
                        alt
                      />
                      <img
                        v-else
                        style="
                          display: block;
                          display: inline-flex;
                          margin-right: 20px;
                        "
                        :src="
                          curso.detalles_compras.compras_productos[0].foto_principal.replace(
                            'http:',
                            'https:'
                          )
                        "
                        alt
                      />
                    </div>
                  </div>
                  <div class="col col-md-9">
                    {{ curso.detalles_compras.compras_productos[0].producto }}
                  </div>
                </div>
              </a>
            </span>
          </li>
        </ul>
        <ul v-if="!isLoggedIn">
          <li>
            <a href="https://blog.topclass.cl/" target="blank" class="text-white" style="margin-left:10px; margin-right: 10px;">
              BLOG
            </a>
          </li>
        </ul>
      </div>
    </div>
    <b-modal
      v-model="site.isPortalLoginModalVisible"
      :busy="true"
      centered
      hide-footer
      title="Iniciar sesión"
    >
      <login-form
        @submit="loginSubmit"
        @loginSuccessful="loggedIn"
        @loginError="loginError"
      ></login-form>
    </b-modal>
    <b-modal
      v-model="site.isPortalRegistroModalVisible"
      :busy="true"
      centered
      title="Crear Cuenta"
    >
      <registro-form
        @submit="loginSubmit"
        @registroSuccessful="loggedIn"
        @registroError="loginError"
      ></registro-form>
      <div slot="modal-footer"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import LoginForm from "./LoginForm";
import RegistroForm from "./RegistroForm";
import { wait } from "../utilities/util";

export default {
  components: {
    bModal,
    LoginForm,
    RegistroForm,
  },
  directives: {
    "b-modal": bModalDirective,
  },
  inject: ["$cloudinary"],
  data() {
    return {
      isUserMenuVisible: false,
      isMenuVisible: false,
      isCursoMenuVisible: false,
    };
  },
  computed: {
    misCursos() {
      let cursos = [];
      let cursos_duplicados = [];

      if (this.user && this.user.mis_compras != null) {
        if (this.user.mis_compras.length > 0) {
          cursos.push(this.user.mis_compras);
        }
        if (this.user.mis_regalos.length > 0 && this.user.mis_compras != null) {
          cursos.push(this.user.mis_regalos);
        }

        if (
          this.user.mis_compras_moviles.length > 0 &&
          this.user.mis_regalos != null &&
          this.user.mis_compras != null
        ) {
          cursos.push(this.user.mis_compras_moviles);
        }

        if (this.user.mis_compras_app.length > 0) {
          cursos.push(this.user.mis_compras_app);
        }

        //VALIDA NO MOSTRAR CURSOS REPETIDOS
        if (typeof cursos[0] !== "undefined") {
          cursos[0].forEach((content1) => {
            var add_curso = true;

            if (typeof content1.detalles_compras !== "undefined") {
              for (var i = 0; i < cursos_duplicados.length; i++) {
                console.log(
                  "VER ITERACCION " +
                    content1.detalles_compras.compras_productos[0].id_producto +
                    " " +
                    cursos_duplicados[i].detalles_compras.compras_productos[0]
                      .id_producto
                );

                if (
                  content1.detalles_compras.compras_productos[0].id_producto ==
                  cursos_duplicados[i].detalles_compras.compras_productos[0]
                    .id_producto
                ) {
                  add_curso = false;
                }
              }

              if (add_curso) {
                cursos_duplicados.push(content1);
              }
            }
          });
        }

        //console.log("DUPLICADOS",cursos_duplicados);
      }
      return cursos_duplicados;
    },
    isLoggedIn() {
      if (
        this.user.movistar_sat == "PENDIENTE" &&
        this.$route.name != "HomeChangeMovil"
      ) {
        window.location.href = "/seleccionar-curso";
      }

      return this.user.id !== 0;
    },
    userHasPhoto() {
      if ("public_id" in this.user)
        if (this.user.public_id != "" && this.user.public_id != null)
          return true;
      return false;
    },
    userPhoto() {
      // console.log("computed userphoto");
      return (
        "url(" +
        (this.userPublicId == ""
          ? require(`@/assets/images/anon.svg`)
          : this.resizePhoto(this.userPublicId)) +
        ")"
      );
    },
    userPublicId() {
      return this.user.public_id;
    },
    paginas() {
      return this.portal.portales_paginas.filter(
        (page) => page.destacado_header == 1
      );
    },
    ...mapState(["portal", "user", "site", "isPortalReady"]),
    ...mapGetters(["userId"]),
  },
  methods: {
    getCategoriaProducto(producto) {
      //console.log({ producto });
      if (producto.compras_productos_categoria.length > 0)
        return this.portal.categorias.find(
          (cat) =>
            cat.id == producto.compras_productos_categoria[0].id_categoria
        );
    },
    loggedIn(response) {
      if (response.data == "OK" && response.response == 200) {
        this.$store.commit("togglePortalLoginModal", false);
        this.$store.commit("togglePortalBarraPrecioFooterModal", false);
      }
    },
    registroIn(response) {
      if (response.data == "OK" && response.response == 200) {
        this.$store.commit("togglePortalLoginModal", false);
        this.$store.commit("togglePortalBarraPrecioFooterModal", false);
      }
    },
    loginError() {},
    loginSubmit() {
      // console.log("iniciar sesion");
    },
    logout(redireccionar = true) {
      this.isUserMenuVisible = false;
      this.isCursoMenuVisible = false;
      this.$store
        .dispatch("logout")
        .then((response) => {
          localStorage.setItem("name_user", "Visitante");
          localStorage.setItem("email_user", "Visitante");
          if (redireccionar) {
            this.$router.push({ name: "home" });
          }
        })
        .catch((error) => {});
    },
    resizePhoto(public_id) {
      // console.log("cloud", this.$cloudinary);
      let convert = this.$cloudinary.url(public_id, {
        width: 250,
        height: 250,
        gravity: "faces",
        crop: "fill",
      });
      // console.log({ convert });
      return convert;
    },
    setPhoto() {
      // console.log("pid", this.userpid);
      this.smallPhoto =
        this.userPublicId != ""
          ? this.$cloudinary.url(this.userPublicId, {
              width: 200,
              height: 200,
            })
          : require(`@/assets/images/default-user-icon.svg`);
    },
    toggleLoginModal(toggle) {
      this.$store.commit("togglePortalLoginModal", toggle);
      if (screen.width <= 500) {
        this.$store.commit("togglePortalBarraPrecioFooterModal", toggle);
      }
    },
    toggleRegistroModal(toggle) {
      this.$store.commit("togglePortalRegistroModal", toggle);
      if (screen.width <= 500) {
        this.$store.commit("togglePortalBarraPrecioFooterModal", toggle);
      }
    },
    toggleUserMenu() {
      this.isUserMenuVisible = !this.isUserMenuVisible;
    },
    toggleCursoMenu() {
      this.isCursoMenuVisible = !this.isCursoMenuVisible;
    },
    toggleMenu() {
      this.$store.commit("setIsSiteMenuVisible", !this.site.isSiteMenuVisible);
    },
    clickMenu(estatica) {
      this.$router.push({
        path: estatica.path,
      });
      this.$store.commit("setIsSiteMenuVisible", false);
    },
    Chat() {
      var date = new Date();
      var timestamp = date.getTime() / 1000;

      let chat;

      if (localStorage.getItem("name_user") == "Visitante") {
        chat = {
          app_id: "x1lmc8zv", //x1lmc8zv production
        };
      } else {
        chat = {
          app_id: "x1lmc8zv", //qntq3spx testing
          name: localStorage.getItem("name_user"), // Full name
          email: localStorage.getItem("email_user"), // Email address
          created_at: timestamp, // Signup date
        };
      }
      //console.log("CHAT",chat)
      window.intercomSettings = chat;
    },
  },
  mounted() {
    setInterval(() => {
      if (
        screen.width <= 500 &&
        !this.site.isPortalRegistroModalVisible &&
        !this.site.isPortalLoginModalVisible
      ) {
        this.$store.commit("togglePortalBarraPrecioFooterModal", false);
      }
    }, 500);
  },
  created() {
    (function (e, a) {
      var t,
        r = e.getElementsByTagName("head")[0],
        c = e.location.protocol;
      t = e.createElement("script");
      t.type = "text/javascript";
      t.charset = "utf-8";
      t.async = !0;
      t.defer = !0;
      t.src = c + "//front.optimonk.com/public/" + a + "/js/preload.js";
      r.appendChild(t);
    })(document, "51458");

    if (typeof this.$route.query.operador === "undefined") {
      this.Chat();
    }

    var referencia = document.referrer.split("/");
    var actual = document.location.href.split("/");
    if (
      typeof referencia[2] !== "undefined" &&
      localStorage.getItem("utm_medium") != referencia[2] &&
      localStorage.getItem("utm_source") != referencia[2] &&
      actual[2] != referencia[2]
    ) {
      if (
        localStorage.getItem("utm_medium") == "" &&
        localStorage.getItem("utm_medium") != "referencia"
      ) {
        localStorage.setItem("utm_medium", "referencia");
        localStorage.setItem("utm_source", referencia[2]);
      }
    }

    if (
      typeof this.$route.query.registro !== "undefined" &&
      this.$route.query.registro == 1
    ) {
      this.$store.commit("togglePortalRegistroModal", true);
    }

    if (typeof this.$route.query.code_referred !== "undefined") {
      this.$store.commit("togglePortalRegistroModal", true);
    }

    if (
      typeof this.$route.query.login !== "undefined" &&
      this.$route.query.login == 1
    ) {
      this.$store.commit("togglePortalLoginModal", true);
    }

    if (typeof this.$route.query.utm_source !== "undefined") {
      localStorage.setItem("utm_source", this.$route.query.utm_source);
    }

    if (typeof this.$route.query.utm_medium !== "undefined") {
      localStorage.setItem("utm_medium", this.$route.query.utm_medium);
    }

    if (typeof this.$route.query.utm_campaign !== "undefined") {
      localStorage.setItem("utm_campaign", this.$route.query.utm_campaign);
    }

    if (typeof this.$route.query.code_referred !== "undefined") {
      localStorage.setItem("code_referred", this.$route.query.code_referred);
    }
  },
};
</script>

